import React from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';
import BlogTile from './BlogTile';

// Move blog posts to a separate data file
export const BLOG_POSTS = [
  {
    slug: 'pressure-washing-benefits',
    title: 'The Benefits of Professional Pressure Washing for Your Home',
    date: '2026-04-24',
    summary: "Discover how professional pressure washing can enhance your home's curb appeal, protect your investment, and create a healthier environment for your family.",
    image: '/benefits_pressure_washing_blog_hero.jpeg',
    content: [
      {
        type: 'paragraph',
        text: "Pressure washing is one of the most effective ways to maintain your home's exterior. Not only does it remove dirt, mold, and mildew, but it also helps prevent long-term damage to your property."
      },
      {
        type: 'heading',
        text: 'Why Pressure Washing Matters'
      },
      {
        type: 'paragraph',
        text: "Over time, grime and environmental pollutants can build up on your home's surfaces. Professional pressure washing can:"
      },
      {
        type: 'list',
        items: [
          'Boost curb appeal instantly',
          'Protect siding, brick, and concrete from deterioration',
          'Create a healthier environment by removing allergens',
          'Increase property value'
        ]
      },
      {
        type: 'heading',
        text: 'How Often Should You Pressure Wash?'
      },
      {
        type: 'paragraph',
        text: "Most homes benefit from annual pressure washing, but high-traffic areas or properties in dusty climates may need more frequent cleaning."
      },
      {
        type: 'quote',
        text: '"A clean home is a happy home!"'
      },
      {
        type: 'paragraph',
        text: 'Ready to see the difference? Contact us today for a free quote!'
      }
    ]
  },
  {
    slug: 'cleaning-house-siding-tips',
    title: 'How to Clean Every Type of House Siding: Pro Tips for Vinyl, Brick, Wood, and Stucco',
    date: '2026-04-25',
    summary: "Learn the best techniques and safety tips for cleaning your home's exterior—vinyl, brick, wood, or stucco—without causing damage. Discover pro advice for a sparkling, damage-free finish!",
    image: 'https://images.pexels.com/photos/5248733/pexels-photo-5248733.jpeg?auto=compress&cs=tinysrgb&w=600',
    content: [
      {
        type: 'paragraph',
        text: "Keeping your home's exterior clean not only boosts curb appeal but also protects your investment. But did you know that the right cleaning method depends on your siding material? Using the wrong pressure or detergent can cause costly damage. Here's how to clean every type of house siding like a pro!"
      },
      {
        type: 'heading',
        text: 'Vinyl Siding: Keep It Bright Without Damage'
      },
      {
        type: 'list',
        items: [
          'Pressure: Medium-duty (2,000–2,800 PSI) with a 25° or 40° nozzle (green or white).',
          'Technique: Hold the wand 12–18 inches from the surface at a 45° angle. Work from top to bottom to prevent streaks. Use a low-pressure soap nozzle to apply a pH-neutral, vinyl-safe detergent. Let it sit for 5–10 minutes, then rinse.',
          'Detergent: Choose environmentally friendly, vinyl-safe cleaners. Avoid bleach, which can harm vinyl and landscaping.',
          'Pro Tip: Test a small area first. Never spray upward—this can force water behind the siding.'
        ]
      },
      {
        type: 'heading',
        text: 'Brick Siding: Clean Without Eroding Mortar'
      },
      {
        type: 'list',
        items: [
          'Pressure: Medium to high (2,000–3,000 PSI) with a 15° or 25° nozzle. For older brick, use lower pressure (1,500 PSI) and a 40° nozzle.',
          'Technique: Inspect for cracks or loose mortar and repair before cleaning. Apply an alkaline detergent for grease or an oxidizer for mildew. Let it sit for 10 minutes, then rinse in overlapping strokes, 8–12 inches from the surface.',
          'Detergent: Alkaline for grease; hydrogen peroxide for organic growth.',
          'Pro Tip: For pre-1950s brick, always use lower pressure to avoid damaging soft mortar.'
        ]
      },
      {
        type: 'heading',
        text: 'Wood Siding: Gentle Cleaning for Natural Beauty'
      },
      {
        type: 'list',
        items: [
          'Pressure: Light-duty (1,500–2,000 PSI) with a 40° nozzle.',
          "Technique: Work with the grain, 12–18 inches away. Use a wood-safe, biodegradable detergent. Let it soak for 5–10 minutes, then rinse gently. Don't linger in one spot.",
          'Detergent: Wood-specific, biodegradable cleaners.',
          'Pro Tip: After cleaning, let the wood dry for 24–48 hours, then apply a sealant to protect against moisture.'
        ]
      },
      {
        type: 'heading',
        text: 'Stucco: Clean Porous Surfaces Without Pitting'
      },
      {
        type: 'list',
        items: [
          'Pressure: Light to medium (1,500–2,000 PSI) with a 40° nozzle.',
          'Technique: Use a wide, sweeping motion, 12–18 inches away. Apply a mild, pH-neutral detergent to loosen dirt and algae. Rinse thoroughly to prevent residue.',
          'Detergent: pH-neutral or mild alkaline cleaners.',
          'Pro Tip: Check for cracks before washing—high pressure can worsen damage. Seal after cleaning for longer-lasting results.'
        ]
      },
      {
        type: 'heading',
        text: 'Final Thoughts'
      },
      {
        type: 'paragraph',
        text: "No matter your home's exterior, the right cleaning method makes all the difference. If you're unsure or want a professional touch, contact Copper Canyon Pressure Wash for expert, eco-friendly service!"
      }
    ]
  },
  {
    slug: 'driveway-cleaning-guide',
    title: 'The Ultimate Guide to Cleaning Different Types of Driveways',
    date: '2026-04-27',
    summary: "Learn professional techniques for cleaning concrete, asphalt, and paver driveways. Discover the right pressure settings, detergents, and methods to achieve spotless results without damaging your surface.",
    image: '/patio.JPG',
    content: [
      {
        type: 'paragraph',
        text: "Your driveway is one of the first things visitors notice about your home. Whether it's concrete, asphalt, or pavers, regular cleaning not only enhances curb appeal but also extends the life of your driveway. However, each material requires specific care to prevent damage while effectively removing stains and grime."
      },
      {
        type: 'heading',
        text: 'Concrete Driveways: Power and Precision'
      },
      {
        type: 'paragraph',
        text: "Concrete driveways are durable but can show stains easily. Here's how to clean them effectively:"
      },
      {
        type: 'list',
        items: [
          'Pressure: Use heavy-duty (2,900–3,300 PSI) with a 15° or 25° nozzle for general cleaning',
          'Technique: Sweep debris first, then apply a concrete-specific degreaser to stains. Let it sit for 10–15 minutes. Use a surface cleaner attachment for uniform cleaning, working in 10x10-foot sections',
          'Detergent: Use sodium hydroxide for grease, citric acid for rust, and enzymatic cleaners for organic stains',
          'Pro Tip: For stubborn stains, pre-treat with a stiff brush and diluted detergent before washing'
        ]
      },
      {
        type: 'heading',
        text: 'Asphalt Driveways: Gentle Yet Effective'
      },
      {
        type: 'paragraph',
        text: "Asphalt requires a more delicate approach to prevent surface damage:"
      },
      {
        type: 'list',
        items: [
          'Pressure: Medium (2,000–2,800 PSI) with a 25° or 40° nozzle to avoid scarring',
          'Technique: Clear debris, apply degreaser to oil stains, and let it sit for 10 minutes. Use a surface cleaner for even cleaning, keeping the wand 8–12 inches away',
          'Detergent: Use alkaline degreasers for oil and grease. Avoid acidic cleaners',
          'Pro Tip: Sealcoat after cleaning to restore the black finish and protect against UV damage'
        ]
      },
      {
        type: 'heading',
        text: 'Paver Driveways: Careful Cleaning for Lasting Beauty'
      },
      {
        type: 'paragraph',
        text: "Paver driveways require special attention to maintain their appearance and stability:"
      },
      {
        type: 'list',
        items: [
          'Pressure: Light to medium (1,500–2,000 PSI) with a 40° nozzle to avoid dislodging sand',
          'Technique: Sweep loose sand, apply paver-safe detergent, and let it soak for 5–10 minutes. Use a surface cleaner or wide sweeps, keeping the wand 12–18 inches away',
          'Detergent: Use pH-neutral or mild alkaline cleaners to remove dirt and algae',
          'Pro Tip: After cleaning, reapply polymeric sand if needed and seal pavers to enhance color and durability'
        ]
      },
      {
        type: 'heading',
        text: 'Final Thoughts'
      },
      {
        type: 'paragraph',
        text: "Regular cleaning and maintenance are key to keeping your driveway looking its best. If you're unsure about the best approach for your specific driveway or want professional results, contact Copper Canyon Pressure Wash. Our experienced team uses the right equipment and techniques to clean your driveway safely and effectively!"
      }
    ]
  },
  {
    slug: 'stained-concrete-cleaning',
    title: 'How to Clean Stained Concrete: Pro Tips for Oil, Rust, Paint, and Efflorescence',
    date: '2026-04-28',
    summary: "Concrete stains like oil, rust, paint, and efflorescence require specific cleaning methods. Learn how to tackle each type for spotless, restored concrete.",
    image: '/concrete.JPG',
    content: [
      { type: 'paragraph', text: "Concrete often develops stains like oil, rust, paint, or efflorescence, requiring specific pre-treatments and cleaning methods." },
      { type: 'heading', text: 'Oil Stains' },
      { type: 'list', items: [
        'Pre-Treatment: Apply a sodium hydroxide-based degreaser or enzymatic cleaner to break down oil. Scrub with a stiff brush and let it sit for 10–15 minutes.',
        'Pressure: Use 2,900–3,300 PSI with a 15° nozzle or surface cleaner. Work in tight sweeps for stubborn stains.'
      ]},
      { type: 'paragraph', text: "Tip: For set-in stains, repeat the process or use a hot water pressure washer (if available) for better grease removal." },
      { type: 'heading', text: 'Rust Stains' },
      { type: 'list', items: [
        'Pre-Treatment: Apply citric acid or oxalic acid to dissolve rust. Let it sit for 10 minutes, then scrub lightly.',
        'Pressure: Medium to high (2,000–3,000 PSI) with a 15° nozzle. Rinse thoroughly to remove all acid.'
      ]},
      { type: 'paragraph', text: "Tip: Rust may indicate underlying issues (e.g., metal corrosion). Recommend client repairs to prevent recurrence." },
      { type: 'heading', text: 'Paint Stains' },
      { type: 'list', items: [
        'Pre-Treatment: Use a paint stripper or alkaline detergent to loosen paint. Let it sit for 5–10 minutes.',
        'Pressure: High (3,000+ PSI) with a 0° or rotary (turbo) nozzle for precision. Test on a small area to avoid surface damage.'
      ]},
      { type: 'paragraph', text: "Tip: Hot water units can speed up paint removal but require caution to avoid etching concrete." },
      { type: 'heading', text: 'Efflorescence' },
      { type: 'list', items: [
        'Pre-Treatment: Apply diluted citric acid to dissolve the white, powdery deposits. Scrub gently and let it sit for 10 minutes.',
        'Pressure: Medium (2,000–2,800 PSI) with a 25° nozzle. Rinse thoroughly to prevent residue.'
      ]},
      { type: 'paragraph', text: "Tip: Advise sealing post-cleaning to reduce future efflorescence. Etching from acid may require professional resurfacing if overdone." }
    ]
  },
  {
    slug: 'safe-power-washing-pebbletec-pools',
    title: 'How to Safely Power Wash PebbleTec Pool Surfaces: Pro Tips & Warnings',
    date: '2026-04-29',
    summary: "Learn the safest way to power wash PebbleTec pool surfaces without causing damage. Discover expert tips on pressure settings, spray technique, and when to avoid power washing altogether.",
    image: '/pebbletech_hero.jpeg',
    content: [
      {
        type: 'paragraph',
        text: "PebbleTec pool finishes are beautiful and durable, but they require special care when it comes to cleaning. Using the wrong pressure or technique can damage your pool's surface, leading to costly repairs. Here's how to safely power wash your PebbleTec pool deck or interior, plus when to call in a professional."
      },
      {
        type: 'heading',
        text: 'Safe Power Washing Guidelines for PebbleTec Pools'
      },
      {
        type: 'list',
        items: [
          'Use Low Pressure: Keep the pressure under 2,000 PSI (ideally 1,200–1,500 PSI). Too much pressure can dislodge pebbles or etch the surface, shortening the finish\'s lifespan.',
          'Use a Fan Tip (Not a Needle Jet): A wide-angle spray tip (25° or 40°) helps distribute pressure more evenly. Avoid narrow tips that concentrate too much force in one spot.',
          'Test a Small Area First: Try an inconspicuous area to make sure it does not damage the surface.',
          'Keep a Safe Distance: Stay at least 12–18 inches away from the surface while spraying. Move in smooth, sweeping motions.',
          'Avoid Harsh Chemicals: Stick with clean water or mild, pH-neutral cleaners. Avoid bleach or acidic cleaners unless specifically approved for PebbleTec.'
        ]
      },
      {
        type: 'heading',
        text: 'When NOT to Power Wash'
      },
      {
        type: 'paragraph',
        text: "If the surface has visible wear, cracks, or loose pebbles, skip the power washer and opt for a gentle cleaning method or professional acid wash instead."
      },
      {
        type: 'heading',
        text: 'Alternative: Acid Wash (Professionally Done)'
      },
      {
        type: 'paragraph',
        text: "If your PebbleTec has heavy staining or calcium buildup, you might need a light acid wash—but this should be done by a licensed pool professional, not DIY, as it involves hazardous materials and can damage the surface if done incorrectly."
      }
    ]
  },
  {
    slug: 'pressure-washing-composite-deck-warranty',
    title: 'Can Pressure Washing Void the Warranty on Composite Decking? What Homeowners Need to Know',
    date: '2026-04-30',
    summary: "Learn how improper pressure washing can void your composite deck warranty and how to clean safely. Get manufacturer-approved tips for protecting your investment.",
    image: '/composite_decking_hero.jpeg',
    content: [
      {
        type: 'paragraph',
        text: "Composite decking is a popular choice for homeowners who want a low-maintenance, long-lasting outdoor space. But when it comes time to clean that deck, many people wonder: can pressure washing void the warranty? The short answer? Yes, it can — if it's not done correctly."
      },
      {
        type: 'heading',
        text: 'Why Improper Pressure Washing Can Void a Warranty'
      },
      {
        type: 'paragraph',
        text: "Most major composite decking manufacturers — like Trex, TimberTech, and Fiberon — include specific care instructions in their warranty agreements. These often caution against pressure washing that exceeds certain thresholds, such as:"
      },
      {
        type: 'list',
        items: [
          'Using pressure higher than 1,500 PSI',
          'Using a pinpoint nozzle or placing the nozzle too close to the deck',
          'Causing visible damage like surface etching, splintering, or discoloration'
        ]
      },
      {
        type: 'paragraph',
        text: "If your deck suffers damage due to improper cleaning methods, the manufacturer may consider it misuse or neglect — which can void your warranty."
      },
      {
        type: 'heading',
        text: 'The Safe Way: Professional Pressure Washing Done Right'
      },
      {
        type: 'paragraph',
        text: "Hiring a professional pressure washing service that understands composite materials can protect your investment — and your warranty. At Copper Canyon Pressure Wash, we follow best practices recommended by leading manufacturers:"
      },
      {
        type: 'list',
        items: [
          'We use low-pressure settings (under 1,500 PSI)',
          'We use fan-tip nozzles — never zero-degree pinpoint tips',
          'We maintain a safe distance (usually 8–12 inches from the surface)',
          'We only use approved cleaning agents that won\'t harm composite decking'
        ]
      },
      {
        type: 'paragraph',
        text: "This ensures your deck gets clean without compromising its integrity — or your warranty."
      },
      {
        type: 'heading',
        text: 'Protecting Your Warranty: What You Can Do'
      },
      {
        type: 'list',
        items: [
          'Read your decking manufacturer\'s care guide',
          'Confirm that your pressure washing provider uses warranty-safe methods',
          'Keep records of your service in case you ever need to show proof of proper maintenance'
        ]
      },
      {
        type: 'heading',
        text: 'Let the Pros Handle It'
      },
      {
        type: 'paragraph',
        text: "Composite decking is built to last — and with the right care, it will. Don't risk damaging it with DIY methods or overly aggressive cleaning."
      }
    ]
  },
  // Future posts can be added here
];

// Create a separate component for the blog tile that doesn't include SEO
export function BlogTilePreview({ post }) {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden flex flex-col h-full">
      <img src={post.image} alt={post.title} className="w-full h-48 object-cover" />
      <div className="p-6 flex flex-col flex-1">
        <Link 
          to={`/blog/${post.slug}`}
          className="text-xl font-semibold text-[#b87c4c] mb-2 hover:underline block"
        >
          {post.title}
        </Link>
        <p className="text-gray-600 mb-4 flex-1">{post.summary}</p>
        <div className="mt-auto pt-2">
        <Link 
          to={`/blog/${post.slug}`}
          className="text-[#8B4513] hover:text-[#6B3410] font-medium"
        >
            Read More &rarr;
        </Link>
        </div>
      </div>
    </div>
  );
}

// Main Blog component with SEO
function Blog() {
  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <SEO 
        title="Pressure Washing Tips & News | Copper Canyon Blog"
        description="Read expert tips, guides, and news about pressure washing, exterior cleaning, and property maintenance in Phoenix. Stay informed with our blog!"
      />
      <section className="mb-12 text-center">
        <h1 className="text-4xl font-bold text-[#4a3f35] mb-4">Copper Canyon Pressure Wash Blog</h1>
        <p className="text-lg text-gray-700 max-w-2xl mx-auto">
          Expert tips, guides, and news about pressure washing, exterior cleaning, and property maintenance.
        </p>
      </section>
      <section className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {BLOG_POSTS.map(post => (
          <BlogTile key={post.slug} post={post} />
        ))}
      </section>
    </main>
  );
}

export default Blog; 

export { default as BlogTile } from "./BlogTile"; 